/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NatModule
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';

/**
 * @desc NAT policy Collection.
 * @author Aravindh Nagarajan, Zhiqian Liu
 */
export class NatPolicyCollection extends Collection {
    constructor(args = {}) {
        const extendedArgs = {
            ...args,
            objectName: 'natpolicy',
            windowElement: 'lazy-load',
        };

        super(extendedArgs);

        this.itemClass_ = this.getAjsDependency_('NatPolicyItem');
    }
}

NatPolicyCollection.ajsDependencies = [
    'NatPolicyItem',
];
